module.exports = __webpack_public_path__ + "img/17.8cfccc3.jpg";